import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import SingleJobCard from "./SingleJobCard";
import AllJobsWrapper from "../../StylesWrappers/AllJobs/showAllJobs";
import { AppDispatch, RootState } from "../../store";
import { wordDate } from "../../utils/date";
import SingleJobDetails from "./singleJobDetails";
import { showSingleJobDetails } from "../../features/allJobs/allJobsSlice";
import Overlay from "../General/overlay";
import Loader from "../General/Loader";

interface ShowAllJobsProps {
  allJobsProps: Object[];
  countCheck: number | string;
}

const ShowAllJobs = ({ allJobsProps, countCheck }: ShowAllJobsProps) => {
  const { isDeleting } = useSelector((store: RootState) => store.deleteStore);
  const { isShowSingleJob } = useSelector(
    (store: RootState) => store.allJobsStore
  );

  const [jobDetails, setJobDetails] = useState<Object | undefined>({});
  const { position, company, jobDescription, jobType, jobStatus }: any =
    jobDetails;

  const dispatch = useDispatch<AppDispatch>();

  // Function to get each job
  const handleSingleJobDetails = (index: string) => {
    dispatch(showSingleJobDetails());
    const foundJob = allJobsProps.find((each: any) => each._id === index);

    setJobDetails(foundJob);
  };

  return (
    <>
      {isDeleting && (
        <Overlay>
          <Loader />
        </Overlay>
      )}
      <AllJobsWrapper>
        <p className="no__job">
          {countCheck} JOB{countCheck === 1 ? "" : "S"} AVAILABLE
        </p>
        <div className="all__jobs__con">
          {allJobsProps?.map((each: any) => {
            const wordDateValue = wordDate(each.createdAt);
            const newEach = {
              ...each,
              date: wordDateValue,
            };
            return (
              <SingleJobCard
                key={each._id}
                {...newEach}
                handleClick={() => handleSingleJobDetails(each._id)}
                allJobsProp={allJobsProps}
              />
            );
          })}
        </div>
        {/* Single job overlay details */}
        {isShowSingleJob && (
          <SingleJobDetails
            position={position}
            company={company}
            jobDescription={jobDescription}
            jobType={jobType}
            jobStatus={jobStatus}
          />
        )}
      </AllJobsWrapper>
    </>
  );
};

export default ShowAllJobs;
